import { MonitoringPhaseHeader } from '@features/monitoringOffer/components/MonitoringPhaseHeader';
import { useAppbarTitle } from '@hooks/useAppbarTitle';
import { usePageTitle } from '@hooks/usePageTitle';
import { useWindowSize } from '@hooks/useWindowSize';
import { mdiArrowLeft } from '@mdi/js';
import Icon from '@mdi/react';
import { Box, Button, CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetCategories, useMonitoringOffersStore } from 'services/monitoring-offers';
import PhaseCategories from '../components/PhaseCategories';

const styles = {
	container: {
		display: 'flex',
		flexDirection: 'column',
		boxShadow: 3,
		position: 'relative',
		bgcolor: 'white',
		borderRadius: 3,
	},
};

export const MonitoringTopicsPage = () => {
	const { selectedOffer } = useMonitoringOffersStore();
	const { id } = useParams();
	const navigate = useNavigate();

	const offer =
		Object.keys(selectedOffer).length === 0
			? JSON.parse(localStorage.getItem('selectedOffer') || '{}')
			: selectedOffer;

	const { data: categories, isLoading, error, refetch } = useGetCategories(id, offer.id);
	const { t } = useTranslation();
	const size = useWindowSize();

	// Refetch categories when the component mounts to ensure we get the latest data
	useEffect(() => {
		if (id && offer.id) {
			refetch();
		}
	}, [id, offer.id, refetch]);

	usePageTitle(t('monitoringProtocols'));
	useAppbarTitle('Monitoring Protocols');

	return (
		<Box
			sx={{
				...styles.container,
				minHeight: size.width > 768 ? '100%' : 'auto',
			}}
		>
			<div className="flex justify-center items-center my-5">
				<div className="absolute left-[20px]">
					<Button
						className="w-[120px]"
						type="submit"
						onClick={() => navigate(-1)}
						variant="text"
						sx={{ color: 'black' }}
						startIcon={<Icon path={mdiArrowLeft} size={1} />}
					>
						<span className="max-xsm:hidden">{t('back')}</span>
					</Button>
				</div>
				<h2 className="md:text-2xl font-bold">{t('phases')}</h2>
			</div>
			<div className="p-[20px] pt-0 gap-3 flex flex-col">
				<MonitoringPhaseHeader data={offer} />
				{error ? (
					<div className="flex flex-col items-center justify-center p-8">
						<p className="text-red-500 mb-4">{t('errorLoadingData')}</p>
						<Button variant="contained" color="primary" onClick={() => refetch()}>
							{t('retry')}
						</Button>
					</div>
				) : (
					<PhaseCategories categories={categories} isLoading={isLoading} />
				)}
			</div>
		</Box>
	);
};
